import React from 'react';
import PropTypes from 'prop-types';
import { Box, LinearProgress, Typography } from '@mui/material';
import useThemeStyles from '../../../hooks/useThemeStyles';

const PHASE_LABELS = {
  creating: 'Creating project…',
  importing: 'Importing manuscript…',
  analyzing: 'Analyzing manuscript',
  saving: 'Saving extracted notes…',
};

const ImportProgressPanel = ({ phase, current, total }) => {
  const { colors } = useThemeStyles();
  const determinate = phase === 'analyzing' && total > 0;
  const value = determinate ? Math.round((current / total) * 100) : 0;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, py: 4, px: 2 }}>
      <Typography variant="body1" sx={{ color: colors.text.primary, textAlign: 'center' }}>
        {PHASE_LABELS[phase] || 'Working…'}
        {determinate ? ` (chunk ${current} of ${total})` : ''}
      </Typography>
      <LinearProgress
        variant={determinate ? 'determinate' : 'indeterminate'}
        value={value}
        sx={{ height: 8, borderRadius: 4 }}
      />
      <Typography variant="caption" sx={{ color: colors.text.secondary, textAlign: 'center' }}>
        Keep this window open until the import finishes.
      </Typography>
    </Box>
  );
};

ImportProgressPanel.propTypes = {
  phase: PropTypes.string.isRequired,
  current: PropTypes.number,
  total: PropTypes.number,
};

ImportProgressPanel.defaultProps = {
  current: 0,
  total: 0,
};

export default ImportProgressPanel;
